import humps from 'lodash-humps-ts';
import { omit } from 'lodash';
import { snakes } from '@utils/lodash';
import { authAxios } from '@components/Auth';
import { CancerClaim } from '@models/CancerClaim';
import { InsuranceTypes } from '@models/InsuranceType';
import { API_V1_BASE } from '@config';
import { PaymentInfo } from '@models/PaymentInfo';

export interface CreateCancerClaimParams {
  cancerOrderId: number;
  insuranceType: InsuranceTypes;
  accidentHappenedAt: string;
  supportingDocuments: File[];
  totalClaimedAmount: number;
  acceptTermsAndConditions: boolean;
  mobileNumber: string;
  email?: string;
  paymentInfo: PaymentInfo;
}

export interface GetCancerClaimParams {
  id: number;
}

export class CancerClaimApi {
  static create = async ({ paymentInfo, ...rest }: CreateCancerClaimParams) => {
    return await authAxios
      .postForm(`${API_V1_BASE}/user/cancer_claims`, {
        ...omit(snakes(rest), ['supporting_documents']),
        'payment_info[payment_method]': paymentInfo.paymentMethod,
        'payment_info[bank_name]': paymentInfo.bankName,
        'payment_info[beneficiary_name]': paymentInfo.beneficiaryName,
        'payment_info[bank_account]': paymentInfo.bankAccount,
        'supporting_documents[]': rest.supportingDocuments,
      })
      .then((response) => humps(response.data) as CancerClaim);
  };

  static get = async ({ id }: GetCancerClaimParams) => {
    return await authAxios
      .get(`${API_V1_BASE}/user/cancer_claims/${id}`)
      .then((response) => humps(response.data) as CancerClaim);
  };
}
